module.exports = __webpack_public_path__ + "58271f165950b19fc65dd3509104cf57.svg";